import React from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Checkbox } from '@mui/material';

export const renderCheckboxCell = (params: any, onValueChange: (row: any, value: boolean) => void) => {
  if (params?.row?.isTotalRow) {
    return '';
  }
  const isEditable = params?.isEditable;

  const onChange = (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    onValueChange(params.row, checked);
  };

  return <Checkbox value={params.value} checked={!!params.value} disabled={!isEditable} onChange={onChange} />;
};

export const renderSingleSelectCell = (params: any) => {
  if (params?.row?.isTotalRow) {
    return '';
  }
  const isEditable = params?.isEditable;
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        cursor: 'pointer',
        height: '100%',
        position: 'relative',
        paddingRight: '24px',
      }}
    >
      <span
        style={{
          flex: 1,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {params.value || ''}
      </span>
      {isEditable && (
        <ArrowDropDownIcon
          style={{
            fontSize: '20px',
            color: '#666',
            userSelect: 'none',
            pointerEvents: 'none',
            position: 'absolute',
            right: '4px',
            top: '50%',
            transform: 'translateY(-50%)',
          }}
        />
      )}
    </div>
  );
};
